/* src/app/dialogs/file-uploader/file-uploader.component.css */
.add-files-btn {
  float: right;
}
:host {
  height: 100%;
  display: flex;
  flex: 1;
  flex-direction: column;
}
.actions {
  justify-content: flex-end;
}
.container {
  height: 100%;
}
/*# sourceMappingURL=file-uploader.component-T3NPKJ57.css.map */
